function P2DrugVO(id, name, packages, drugType, commonName, strength, form, accountableSubject, procedureType,
                  licenseNumber, licenseValidityDate, ATCcode, asbestosis, bloodDonor, pregnant, senior) {
    this.id = id;

    this.name = name;
    this.packages = packages;
    this.drugType = drugType;
    this.commonName = commonName;
    this.strength = strength;
    this.form = form;
    this.accountableSubject = accountableSubject;
    this.procedureType = procedureType;
    this.licenseNumber = licenseNumber;
    this.licenseValidityDate = licenseValidityDate;
    this.ATCcode = ATCcode;
    this.asbestosis = asbestosis;
    this.bloodDonor = bloodDonor;
    this.pregnant = pregnant;
    this.senior = senior;

    var _typeContext = {
        licenseValidityDate: Date,
        packages: P2DrugPackageVO
    };

    this._getType = function (property) {
        if (_typeContext.hasOwnProperty(property)) {
            return _typeContext[property];
        }
        else {
            return undefined;
        }
    };

    var _mappingContext = {
    };

    this._getMapping = function (property) {
        if (_mappingContext[property]) {
            return _mappingContext[property];
        }
        else {
            return undefined;
        }
    };
}
